import Accordion from '@components/Accordion';
import BlankStamp from '@components/blank/BlankStamp';
import Column from '@components/Column';
import Divider from '@components/Divider';
import Header from '@components/Header';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import Fab from './components/Fab';
import StampCard from './components/StampCard';
import StampHeader from './components/StampHeader';
import useStampCards from './hooks/useStampCards';
import styles from './styles.module.scss';

const StampsActivity: ActivityComponentType = () => {
  const stampCards = useStampCards();
  return (
        <AppScreen>
            <Column fullWidth className={styles.container} >
                <Header title='스탬프 카드'/>
                <StampHeader stampCards={stampCards}/>
                <Column fullWidth
                        as='section'
                        spacing={16}
                        className={styles.contents}>
                    {stampCards?.map((stampCard) => (
                        <StampCard stampCard={stampCard}
                                   key={stampCard.shopId} />
                    ))}
                    {(stampCards?.length || 0) < 1 && (
                        <BlankStamp/>
                    )}
                </Column>
                <Divider/>
                <Accordion title='유의사항' >
                    <Text color={colors.gray6} as='div'>
                        <Ol>
                            <li>아이스크림 포함, 제조 음료에 한하여 스탬프가 적립됩니다.&nbsp;
                                (디저트, MD, 베이커리 등 구매 시에는 적립되지 않습니다.)</li>
                            <li>쿠폰, 모바일 상품권, 금액권 등으로 결제 시 스탬프는 미적립됩니다.</li>
                            <li>유효기간이 지난 스탬프는 자동 소멸됩니다.</li>
                        </Ol>
                    </Text>
                </Accordion>
                <Fab/>
            </Column>
        </AppScreen>
  );
};

const Ol = styled.ol`
    list-style-type: decimal;
    list-style-position: outside;
    padding-inline-start: 18px;
`;

export default StampsActivity;
